import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import getDates from "../../../shared/services/date.service";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { NavLink } from "react-router-dom";

class LogisticReportsTaskTripItem extends Component {
  render() {
    const { taskTrip, onSetViewPanel } = this.props;

    return (
      <div className={styles.reportItemContainer}>
        <div className={styles.columnItem}>
          <div
            onClick={(e) => {
              e.stopPropagation();
              onSetViewPanel("taskTripReport");
            }}
          >
            <b>Рейс: </b>
            <TooltipWrapper title={`Просмотреть рейс ${taskTrip.title}`} position="top">
              <NavLink to={`/logistic/reports/${taskTrip.id}`}>
                <span> {taskTrip.title}</span>
              </NavLink>
            </TooltipWrapper>
          </div>

          <div>
            <b>Начало: </b> <span> {getDates.getDateFormat8(taskTrip.timeStart)}</span>
          </div>

          <div>
            <b>Окончание: </b> <span> {getDates.getDateFormat8(taskTrip.timeEnd)}</span>
          </div>
        </div>

        <div className={styles.columnItem}>
          <div>
            <b>Состояние: </b> <span> {taskTrip.isCompleted ? "Завершен" : "В процессе"}</span>
          </div>

          <div>
            <b>Исполнение: </b>{" "}
            <span style={{ color: taskTrip.isViolation ? "red" : "black" }}>
              {taskTrip.isViolation ? "С нарушениями" : "Без нарушений"}
            </span>
          </div>
        </div>

        <div className={styles.columnItem}>
          {taskTrip.units.map((unit) => {
            return (
              <div key={unit.id} style={{ marginBottom: "10px" }}>
                <div>
                  <b>Транспортное средство: </b> <span> {unit.title}</span>
                </div>

                <div>
                  <b>Регистрационный номер: </b> <span> {unit.registerNumber}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default React.memo(LogisticReportsTaskTripItem);
